import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {ApplicationRef, ComponentFactoryResolver, NgModule, Type} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {CollectionSearchComponent} from "./collection-search/collection-search.component";
import {CollectionSearchModule} from "./collection-search/collection-search.module";

import {ContentSearchComponent} from "./content-search/content-search.component";
import {ContentSearchModule} from "./content-search/content-search.module";

import {AddToCartWidgetComponent} from "./product-details/components/add-to-cart-widget/add-to-cart-widget.component";
import {WishlistWidgetComponent} from "./product-details/components/wishlist-widget/wishlist-widget.component";
import {CofaWidgetComponent} from "./product-details/components/cofa-widget/cofa-widget.component";
import {ProductDetailsModule} from "./product-details/product-details.module";

import {NotificationsWidgetComponent} from "./shared/components/notification/notifications-widget/notifications-widget.component";

import {QuickShopComponent} from "./quick-shop/quick-shop.component";
import {QuickShopModule} from "./quick-shop/quick-shop.module";
import {CustomApiInterceptor} from "./shared/interceptors/custom-api-interceptor";

import {SharedModule} from "./shared/shared.module";

const entryComponents = [
    QuickShopComponent,
    ContentSearchComponent,
    AddToCartWidgetComponent,
    WishlistWidgetComponent,
    CofaWidgetComponent,
    CollectionSearchComponent,
    NotificationsWidgetComponent
];

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        SharedModule.forRoot(),
        QuickShopModule,
        ContentSearchModule,
        ProductDetailsModule,
        CollectionSearchModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomApiInterceptor,
            multi: true
        }
    ],
    entryComponents: entryComponents
})
export class AppModule {
    public constructor(private resolver: ComponentFactoryResolver) {
    }

    // noinspection JSUnusedGlobalSymbols
    public ngDoBootstrap(appRef: ApplicationRef): void {
        entryComponents.forEach((componentDef: Type<{}>) => {
            const componentFactory = this.resolver.resolveComponentFactory(componentDef);
            if (document.querySelector(componentFactory.selector)) {
                appRef.bootstrap(componentFactory);
            }
        });
    }
}
